import React, { useState } from "react";
import { ITag } from "../../../models/tags/TagsStore";
import { TagPicker } from "../../forms/tagPicker/tagPicker";
import { ListActionLabel } from "./listActionLabel";
import settingsStyles from "../../../styles/settings.css";

interface Props {
  text: string;
  onPicked(tagId: string): void;
}
export const ListTagAction = ({ text, onPicked }: Props) => {
  const [isPicking, setIsPicking] = useState(false);

  const handlePicked = (tag: ITag) => {
    onPicked(tag.id);
    setIsPicking(false);
  };

  return isPicking ? (
    <TagPicker
      onOutsideClick={() => setIsPicking(false)}
      className={settingsStyles["input-width"]}
      onChange={handlePicked}
      onStateChange={(_, state) => (!state.isOpen ? setIsPicking(false) : undefined)}
      initialIsOpen
    />
  ) : (
    <ListActionLabel text={text} onClick={() => setIsPicking(true)} />
  );
};
